import { computed, makeObservable } from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../../../../domain';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {MQMatchingQuestion} from '../../models';
import {TeacherDndMatchingQuestion} from './TeacherDndMatchingQuestion';
import {TeacherDropdownMatchingQuestion} from './TeacherDropdownMatchingQuestion';

interface PropsType {
  x9: X9Content | X9ContentSnapshot,
  store: X9ContentStateStore
}

@observer
export class TeacherMatchingQuestion extends React.Component<PropsType> {
  constructor(props: PropsType) {
    super(props);
    makeObservable(this);
  }

  @computed
  get model(): MQMatchingQuestion {
    return JSON.parse(this.props.x9.Contents) as MQMatchingQuestion;
  }

  render() {
    const behavior = this.model.options.behavior;
    const id = this.props.x9.Id;

    if (behavior === 'dropdown')
      return (
        <TeacherDropdownMatchingQuestion id={id}
                                         question={this.model}
                                         store={this.props.store}/>);

    if (behavior === 'dragdrop')
      return (
        <TeacherDndMatchingQuestion id={id}
                                    question={this.model}
                                    store={this.props.store}/>);

    return null;
  }
}
